import React from 'react';
import cx from 'classnames';


const SubHeader = ({className = '', title = '', subtitle = null, content = null}) => {

    const classes = cx(className, 'bg-gradient-to-b from-gray-50 to-gray-150', 'h-36', 'flex-shrink-0');
    return (
        <div className={classes}>
            <div className="container h-full grid grid-cols-2 grid-flow-row">
                <div className="flex flex-col justify-center items-start">
                    <h1 className='font-bold text-4xl pb-2'>{title}</h1>
                    {
                        typeof subtitle == 'function'
                            ? (subtitle())
                            : (<p className="text-gray-410">{subtitle}</p>)
                    }
                </div>
                {
                    typeof content == 'function'
                        ? (content())
                        : (<p className="text-gray-410">{content}</p>)
                }
            </div>
        </div>
    );
};

export default SubHeader;